import React from 'react';
import { Hammer, DollarSign, TrendingUp, ShieldCheck, Smartphone } from 'lucide-react';
export function AchievementsSection() {
  const achievements = [{
    icon: <Hammer className="w-8 h-8 text-amber-500" aria-hidden="true" data-id="element-14" />,
    text: 'Saber exactamente qué materiales comprar y cuánto gastar'
  }, {
    icon: <ShieldCheck className="w-8 h-8 text-amber-500" aria-hidden="true" data-id="element-15" />,
    text: 'Aplicar pisos epoxi sin miedo a arruinar el trabajo'
  }, {
    icon: <DollarSign className="w-8 h-8 text-amber-500" aria-hidden="true" data-id="element-16" />,
    text: 'Cotizar con números reales y margen de ganancia'
  }, {
    icon: <TrendingUp className="w-8 h-8 text-amber-500" aria-hidden="true" data-id="element-17" />,
    text: 'Evitar los errores que hacen perder plata y clientes'
  }, {
    icon: <Smartphone className="w-8 h-8 text-amber-500" aria-hidden="true" data-id="element-18" />,
    text: 'Conseguir tus primeros clientes con un sistema probado'
  }];
  return <section className="py-16 px-4 bg-[#111]" aria-label="Beneficios del sistema" data-id="element-19">
      <div className="max-w-4xl mx-auto" data-id="element-20">
        <h2 className="text-3xl md:text-4xl font-black text-center mb-12 text-white uppercase tracking-tight" data-id="element-21">
          ¿Qué vas a poder hacer?
        </h2>

        <ul className="grid gap-6 list-none p-0" data-id="element-22">
          {achievements.map((item, index) => <li key={index} className="bg-[#1a1a1a] p-6 rounded-xl border border-gray-800 flex items-center gap-6 hover:border-amber-800/50 transition-colors" data-id="element-23">
              <div className="bg-[#222] p-3 rounded-full flex-shrink-0" data-id="element-24">
                {item.icon}
              </div>
              <p className="text-lg md:text-xl font-semibold text-gray-200" data-id="element-25">
                {item.text}
              </p>
            </li>)}
        </ul>

        <div className="mt-12 text-center" data-id="element-26">
          <p className="text-xl md:text-2xl font-bold text-amber-400 bg-amber-900/10 inline-block px-6 py-3 rounded-lg border border-amber-900/30" data-id="element-27">
            Todo ordenado para que en pocas semanas puedas estar cobrando tu
            primer trabajo.
          </p>
        </div>
      </div>
    </section>;
}